import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import { useState } from 'react';

import {
  SubmitAnEpisodeStartBody,
  SubmitAnEpisodeStartFooter,
} from './submit-an-episode-start';
import {
  SubmitAnEpisode1Body,
  SubmitAnEpisode1Footer,
} from './submit-an-episode-1';

const SubmitAnEpisode = ({ modal }: { modal: any }) => {
  const [tutorialModalContent, setTutorialModalContent] = useState(
    'submitAnEpisodeStart'
  );

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={() => {
          modal.onClose();
          modal.openChecklistModal();
          setTutorialModalContent('submitAnEpisodeStart');
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW="800px">
          <ModalCloseButton color="gray.500" />
          <ModalBody px="60px" pt="40px" pb="24px" bg="white">
            {tutorialModalContent === 'submitAnEpisodeStart' && (
              <SubmitAnEpisodeStartBody />
            )}
            {tutorialModalContent === 'submitAnEpisode1' && (
              <SubmitAnEpisode1Body />
            )}
          </ModalBody>
          <ModalFooter
            flexDirection="column"
            alignItems="center"
            bg="gray.100"
            px="60px"
            py="25px"
          >
            {tutorialModalContent === 'submitAnEpisodeStart' && (
              <SubmitAnEpisodeStartFooter
                setNextModal={setTutorialModalContent}
              />
            )}
            {tutorialModalContent === 'submitAnEpisode1' && (
              <SubmitAnEpisode1Footer
                completed={modal.completed}
                closeModal={() => {
                  modal.onClose();
                  modal.openChecklistModal();
                  setTutorialModalContent('submitAnEpisodeStart');
                }}
              />
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SubmitAnEpisode;
